const reportColumnTypes = {
  patientId: {
    key: "patientId",
    dataIndex: "patientId",
    title: "Patient TM ID",
    display: true,
    mandatory: true
  },
  patient: {
    key: "patient",
    dataIndex: "patient",
    title: "Patient TM ID",
    display: true,
    mandatory: true
  },
  mrn: {
    key: "mrn",
    dataIndex: "mrn",
    title: "MRN",
    display: true,
    mandatory: true
  },
  patientName: {
    key: "patientName",
    dataIndex: "patientName",
    title: "Patient Name",
    display: true,
    mandatory: true
  },
  dob: {
    key: "dob",
    dataIndex: "dob",
    title: "DOB",
    display: true,
    mandatory: true
  },
  application: {
    key: "application",
    dataIndex: "application",
    title: "TM Enrollment ID",
    display: true,
    mandatory: true
  },
  assistanceprogramapplication: {
    key: "assistanceprogramapplication",
    dataIndex: "assistanceprogramapplication",
    title: "TM Enrollment ID",
    display: true,
    mandatory: true
  },
  applicationId: {
    key: "applicationId",
    dataIndex: "applicationId",
    title: "Program Application ID",
    display: true,
    mandatory: false
  },
  memberId: {
    key: "memberId",
    dataIndex: "memberId",
    title: "Program Member ID",
    display: true,
    mandatory: false
  },
  status: {
    key: "status",
    dataIndex: "status",
    title: "Enrollment Status",
    display: true,
    mandatory: false
  },
  isExhausted: {
    key: "isExhausted",
    dataIndex: "isExhausted",
    title: "Exhausted",
    display: true,
    mandatory: false
  },
  applicationExpired: {
    key: "applicationExpired",
    dataIndex: "applicationExpired",
    title: "Expired",
    display: true,
    mandatory: false
  },
  isIrrelevantForRenewal: {
    key: "isIrrelevantForRenewal",
    dataIndex: "isIrrelevantForRenewal",
    title: "Renewal Marked Irrelevant",
    display: true,
    mandatory: false
  },
  createdAt: {
    key: "createdAt",
    dataIndex: "createdAt",
    title: "Enrollment Creation Date",
    display: true,
    mandatory: false
  },
  userName: {
    key: "userName",
    dataIndex: "userName",
    title: "Enrollment Assignee",
    display: true,
    mandatory: false
  },
  enrollmentAssigneeName: {
    key: "assigneeName",
    dataIndex: "assigneeName",
    title: "Enrollment Assignee",
    display: true,
    mandatory: false
  },
  enrollmentUserGroup: {
    key: "userGroup",
    dataIndex: "userGroup",
    title: "Enrollment Assignee Group",
    display: true,
    mandatory: false
  },
  userGroup: {
    key: "userGroup",
    dataIndex: "userGroup",
    title: "Claim Assignee Group",
    display: true,
    mandatory: false
  },
  pharmacyUserGroup: {
    key: "userGroup",
    dataIndex: "userGroup",
    title: "Pharmacy Assignee Group",
    display: true,
    mandatory: false
  },
  patientFacility: {
    key: "patientFacility",
    dataIndex: "patientFacility",
    title: "Patient Facility",
    display: true,
    mandatory: false
  },
  savingsType: {
    key: "savingsType",
    dataIndex: "savingsType",
    title: "Savings Type",
    display: true,
    mandatory: false
  },
  assistanceType: {
    key: "assistanceType",
    dataIndex: "assistanceType",
    title: "Savings Sub-Type",
    display: true,
    mandatory: false
  },
  assistanceProgram: {
    key: "assistanceProgram",
    dataIndex: "assistanceProgram",
    title: "Assistance Program Name",
    display: true,
    mandatory: false
  },
  providedBy: {
    key: "providedBy",
    dataIndex: "providedBy",
    title: "Assistance Sponsor",
    display: true,
    mandatory: false
  },
  assistanceProgramName: {
    key: "assistanceProgramName",
    dataIndex: "assistanceProgramName",
    title: "Assistance Program Name",
    display: true,
    mandatory: false
  },
  programSponsor: {
    key: "programSponsor",
    dataIndex: "programSponsor",
    title: "Assistance Sponsor",
    display: true,
    mandatory: false
  },
  approvedAmount: {
    key: "approvedAmount",
    dataIndex: "approvedAmount",
    title: "Max Benefit",
    display: true,
    mandatory: false
  },
  brandName: {
    key: "brandName",
    dataIndex: "brandName",
    title: "Medication Brand",
    display: true,
    mandatory: false
  },
  ingredientName: {
    key: "ingredientName",
    dataIndex: "ingredientName",
    title: "Medication Ingredient",
    display: true,
    mandatory: false
  },
  doseFormCategory: {
    key: "doseFormCategory",
    dataIndex: "doseFormCategory",
    title: "Medication Dose Form Category",
    display: true,
    mandatory: false
  },
  diagnosisDiscovered: {
    key: "diagnosisDiscovered",
    dataIndex: "diagnosisDiscovered",
    title: "Covered Diagnosis",
    display: true,
    mandatory: false
  },
  appliedDate: {
    key: "appliedDate",
    dataIndex: "appliedDate",
    title: "Applied Date",
    display: true,
    mandatory: false
  },
  approvedDate: {
    key: "approvedDate",
    dataIndex: "approvedDate",
    title: "Approved Date",
    display: true,
    mandatory: false
  },

  enrollmentApprovedDate: {
    key: "approvedDate",
    dataIndex: "approvedDate",
    title: "Enrollment Approved Date",
    display: true,
    mandatory: false
  },
  lookbackPeriodStartDate: {
    key: "lookbackPeriodStartDate",
    dataIndex: "lookbackPeriodStartDate",
    title: "Lookback Period Start Date",
    display: true,
    mandatory: false
  },
  validThrough: {
    key: "validThrough",
    dataIndex: "validThrough",
    title: "Valid Through",
    display: true,
    mandatory: false
  },
  effectiveIndefinitely: {
    key: "effectiveIndefinitely",
    dataIndex: "effectiveIndefinitely",
    title: "Effective Indefinitely",
    display: true,
    mandatory: false
  },
  canceledDate: {
    key: "canceledDate",
    dataIndex: "canceledDate",
    title: "Canceled Date",
    display: true,
    mandatory: false
  },
  rejectedDate: {
    key: "rejectedDate",
    dataIndex: "rejectedDate",
    title: "Denied Date",
    display: true,
    mandatory: false
  },
  updatedAt: {
    key: "updatedAt",
    dataIndex: "updatedAt",
    title: "Last Updated Date",
    display: true,
    mandatory: false
  },
  lastUpdatedBy: {
    key: "lastUpdatedBy",
    dataIndex: "lastUpdatedBy",
    title: "Last Updated By",
    display: true,
    mandatory: false
  },
  updatedBy: {
    key: "updatedBy",
    dataIndex: "updatedBy",
    title: "Last Updated By",
    display: true,
    mandatory: false
  },
  tags: {
    key: "tags",
    dataIndex: "tags",
    title: "Tags",
    display: true,
    mandatory: false
  },
  bin: {
    key: "bin",
    dataIndex: "bin",
    title: "Copay BIN",
    display: true,
    mandatory: false
  },
  pcn: {
    key: "pcn",
    dataIndex: "pcn",
    title: "Copay PCN",
    display: true,
    mandatory: false
  },
  group: {
    key: "group",
    dataIndex: "group",
    title: "Copay Group",
    display: true,
    mandatory: false
  },
  expiryDate: {
    key: "expiryDate",
    dataIndex: "expiryDate",
    title: "Card Expiry Date",
    display: true,
    mandatory: false
  },
  zip: {
    key: "zip",
    dataIndex: "zip",
    title: "Patient ZIP",
    display: true,
    mandatory: false
  },
  physicianName: {
    key: "physicianName",
    dataIndex: "physicianName",
    title: "Physician",
    display: true,
    mandatory: false
  },
  planMarket: {
    key: "planMarket",
    dataIndex: "planMarket",
    title: "Primary Plan",
    display: true,
    mandatory: false
  },
  payerName: {
    key: "payerName",
    dataIndex: "payerName",
    title: "Primary Payer",
    display: true,
    mandatory: false
  },
  fundBalance: {
    key: "fundBalance",
    dataIndex: "fundBalance",
    title: "Available Funds",
    display: true,
    mandatory: false
  },
  totalRequestedAmount: {
    key: "totalRequestedAmount",
    dataIndex: "totalRequestedAmount",
    title: "Total Requested Amount",
    display: true,
    mandatory: false
  },
  totalPaidAmount: {
    key: "totalPaidAmount",
    dataIndex: "totalPaidAmount",
    title: "Total Paid Amount",
    display: true,
    mandatory: false
  },
  totalDeniedAmount: {
    key: "totalDeniedAmount",
    dataIndex: "totalDeniedAmount",
    title: "Total Denied Amount",
    display: true,
    mandatory: false
  },
  totalPatientResponsibility: {
    key: "totalPatientResponsibility",
    dataIndex: "totalPatientResponsibility",
    title: "Total Patient Responsibility",
    display: true,
    mandatory: false
  },
  latestPaidDate: {
    key: "latestPaidDate",
    dataIndex: "latestPaidDate",
    title: "Latest Paid Claim",
    display: true,
    mandatory: false
  },
  claimDate: {
    key: "claimDate",
    dataIndex: "claimDate",
    title: "Claim Date",
    display: true,
    mandatory: false
  },
  assigneeName: {
    key: "assigneeName",
    dataIndex: "assigneeName",
    title: "Claim Assignee",
    display: true,
    mandatory: false
  },
  pharmacyAssigneeName: {
    key: "assigneeName",
    dataIndex: "assigneeName",
    title: "Pharmacy Assignee",
    display: true,
    mandatory: false
  },
  facility: {
    key: "facility",
    dataIndex: "facility",
    title: "Claim Facility",
    display: true,
    mandatory: false
  },
  claimId: {
    key: "claimId",
    dataIndex: "claimId",
    title: "Claim ID",
    display: true,
    mandatory: false
  },
  claimStatus: {
    key: "status",
    dataIndex: "status",
    title: "Claim Status",
    display: true,
    mandatory: false
  },
  followUpDate: {
    key: "followUpDate",
    dataIndex: "followUpDate",
    title: "Follow-up Date",
    display: true,
    mandatory: false
  },
  claimServiceDates: {
    key: "claimServiceDates",
    dataIndex: "claimServiceDates",
    title: "Date of Service",
    display: true,
    mandatory: false
  },
  submittedDate: {
    key: "submittedDate",
    dataIndex: "submittedDate",
    title: "Submitted Date",
    display: true,
    mandatory: false
  },
  claimApprovedDate: {
    key: "approvedDate",
    dataIndex: "approvedDate",
    title: "Claim Approved Date",
    display: true,
    mandatory: false
  },
  receivedDate: {
    key: "receivedDate",
    dataIndex: "receivedDate",
    title: "Posted Date",
    display: true,
    mandatory: false
  },
  claimTotalAmount: {
    key: "claimTotalAmount",
    dataIndex: "claimTotalAmount",
    title: "Claim Requested Amount",
    display: true,
    mandatory: false
  },
  paidAmount: {
    key: "paidAmount",
    dataIndex: "paidAmount",
    title: "Claim Paid Amount",
    display: true,
    mandatory: false
  },
  deniedAmount: {
    key: "deniedAmount",
    dataIndex: "deniedAmount",
    title: "Claim Denied Amount",
    display: true,
    mandatory: false
  },
  patientResponsibilityAmount: {
    key: "patientResponsibilityAmount",
    dataIndex: "patientResponsibilityAmount",
    title: "Claim Patient Responsibility",
    display: true,
    mandatory: false
  },
  balance: {
    key: "balance",
    dataIndex: "balance",
    title: "Balance",
    display: true,
    mandatory: false
  },
  payableTo: {
    key: "payableTo",
    dataIndex: "payableTo",
    title: "Payable to",
    display: true,
    mandatory: false
  },
  paymentType: {
    key: "paymentType",
    dataIndex: "paymentType",
    title: "Payment Type",
    display: true,
    mandatory: false
  },
  checkNumber: {
    key: "checkNumber",
    dataIndex: "checkNumber",
    title: "Check number / ACH",
    display: true,
    mandatory: false
  },
  accountNumbers: {
    key: "accountNumbers",
    dataIndex: "accountNumbers",
    title: "Account Number",
    display: true,
    mandatory: false
  },
  claimUpdatedAt: {
    key: "updatedAt",
    dataIndex: "updatedAt",
    title: "Time Since Last Activity",
    display: true,
    mandatory: false
  },
  claimUpdatedBy: {
    key: "updatedBy",
    dataIndex: "updatedBy",
    title: "Last Saved By",
    display: true,
    mandatory: false
  },
  orderDate: {
    key: "orderDate",
    dataIndex: "orderDate",
    title: "Order Date",
    display: true,
    mandatory: false
  },
  facilityValue: {
    key: "facilityValue",
    dataIndex: "facilityValue",
    title: "Pharmacy Facility",
    display: true,
    mandatory: false
  },
  orderId: {
    key: "orderId",
    dataIndex: "orderId",
    title: "TM Order ID",
    display: true,
    mandatory: false
  },
  accountNumber: {
    key: "accountNumber",
    dataIndex: "accountNumber",
    title: "Account Number",
    display: true,
    mandatory: false
  },
  orderType: {
    key: "orderType",
    dataIndex: "orderType",
    title: "Order Type",
    display: true,
    mandatory: false
  },
  orderStatus: {
    key: "orderStatus",
    dataIndex: "orderStatus",
    title: "Order Status",
    display: true,
    mandatory: false
  },
  hcpcs: {
    key: "hcpcs",
    dataIndex: "hcpcs",
    title: "jCode / HCPCs",
    display: true,
    mandatory: false
  },
  drugBrandName: {
    key: "drugBrandName",
    dataIndex: "drugBrandName",
    title: "Medication Brand",
    display: true,
    mandatory: false
  },
  inName: {
    key: "inName",
    dataIndex: "inName",
    title: "Medication Ingredient",
    display: true,
    mandatory: false
  },
  administrationDate: {
    key: "administrationDate",
    dataIndex: "administrationDate",
    title: "Admin Date",
    display: true,
    mandatory: false
  },
  estimatedDelivery: {
    key: "estimatedDelivery",
    dataIndex: "estimatedDelivery",
    title: "Estimated Delivery Date",
    display: true,
    mandatory: false
  },
  arriveDate: {
    key: "arriveDate",
    dataIndex: "arriveDate",
    title: "Received Date",
    display: true,
    mandatory: false
  },
  billVoided: {
    key: "billVoided",
    dataIndex: "billVoided",
    title: "Bill Voided",
    display: true,
    mandatory: false
  },
  billVoidedDate: {
    key: "billVoidedDate",
    dataIndex: "billVoidedDate",
    title: "Bill Voided Date",
    display: true,
    mandatory: false
  },
  isSkipped: {
    key: "isSkipped",
    dataIndex: "isSkipped",
    title: "Skip Order",
    display: true,
    mandatory: false
  },
  dosageUnitAndValue: {
    key: "dosageUnitAndValue",
    dataIndex: "dosageUnitAndValue",
    title: "Dosage",
    display: true,
    mandatory: false
  },
  quantity: {
    key: "quantity",
    dataIndex: "quantity",
    title: "Quantity",
    display: true,
    mandatory: false
  },
  totalAmount: {
    key: "totalAmount",
    dataIndex: "totalAmount",
    title: "Total Order Price",
    display: true,
    mandatory: false
  },
  lotNumberReceived: {
    key: "lotNumberReceived",
    dataIndex: "lotNumberReceived",
    title: "Lot Number Received",
    display: true,
    mandatory: false
  },
  lotNumberDispensed: {
    key: "lotNumberDispensed",
    dataIndex: "lotNumberDispensed",
    title: "Lot Number Dispensed",
    display: true,
    mandatory: false
  },
  orderPhysicianName: {
    key: "orderPhysicianName",
    dataIndex: "orderPhysicianName",
    title: "Physician",
    display: true,
    mandatory: false
  },
  orderUpdatedBy: {
    key: "updatedBy",
    dataIndex: "updatedBy",
    title: "Last Saved By",
    display: true,
    mandatory: false
  },
  orderUpdatedAt: {
    key: "updatedAt",
    dataIndex: "updatedAt",
    title: "Last Saved Date",
    display: true,
    mandatory: false
  },
  serviceDate: {
    key: "serviceDate",
    dataIndex: "serviceDate",
    title: "Date Of Service",
    display: true,
    mandatory: false
  },
  amount: {
    key: "amount",
    dataIndex: "amount",
    title: "Requested Amount",
    display: true,
    mandatory: false
  },
  serviceType: {
    key: "serviceType",
    dataIndex: "serviceType",
    title: "Service Type",
    display: true,
    mandatory: false
  },
  serviceCode: {
    key: "serviceCode",
    dataIndex: "serviceCode",
    title: "Service Code",
    display: true,
    mandatory: false
  },
  bnName: {
    key: "bnName",
    dataIndex: "bnName",
    title: "Medication Brand",
    display: true,
    mandatory: false
  },
  serviceName: {
    key: "serviceName",
    dataIndex: "serviceName",
    title: "Line Item Description",
    display: true,
    mandatory: false
  },
  medicationName: {
    key: "medicationName",
    dataIndex: "medicationName",
    title: "Medication Name",
    display: true,
    mandatory: false
  },
  medicationStrength: {
    key: "medicationStrength",
    dataIndex: "medicationStrength",
    title: "Medication Strength",
    display: true,
    mandatory: false
  },
  manufacturer: {
    key: "manufacturer",
    dataIndex: "manufacturer",
    title: "Manufacturer",
    display: true,
    mandatory: false
  },
  ndc: {
    key: "ndc",
    dataIndex: "ndc",
    title: "NDC",
    display: true,
    mandatory: false
  },
  unitPrice: {
    key: "unitPrice",
    dataIndex: "unitPrice",
    title: "Unit Price",
    display: true,
    mandatory: false
  },
  totalPrice: {
    key: "totalPrice",
    dataIndex: "totalPrice",
    title: "Total Price",
    display: true,
    mandatory: false
  }
};

// Shared by the Orders and Completed Orders line-item selectors; each report keeps
// its own entry in ReportColumns so column visibility is persisted independently (MVP-31003).
const orderLineItemColumnTypes = {
  assigneeName: reportColumnTypes.pharmacyAssigneeName,
  userGroup: reportColumnTypes.pharmacyUserGroup,
  facilityValue: reportColumnTypes.facilityValue,
  patient: reportColumnTypes.patient,
  mrn: reportColumnTypes.mrn,
  patientName: reportColumnTypes.patientName,
  dob: reportColumnTypes.dob,
  orderId: reportColumnTypes.orderId,
  assistanceprogramapplication: reportColumnTypes.assistanceprogramapplication,
  orderDate: reportColumnTypes.orderDate,
  orderStatus: reportColumnTypes.orderStatus,
  medicationName: reportColumnTypes.medicationName,
  medicationStrength: reportColumnTypes.medicationStrength,
  manufacturer: reportColumnTypes.manufacturer,
  ndc: reportColumnTypes.ndc,
  quantity: reportColumnTypes.quantity,
  unitPrice: reportColumnTypes.unitPrice,
  totalPrice: reportColumnTypes.totalPrice,
  lotNumberReceived: reportColumnTypes.lotNumberReceived,
  lotNumberDispensed: reportColumnTypes.lotNumberDispensed
};

const ReportColumns = {
  enrollments: {
    createdAt: reportColumnTypes.createdAt,
    userName: reportColumnTypes.userName,
    userGroup: reportColumnTypes.enrollmentUserGroup,
    patientFacility: reportColumnTypes.patientFacility,
    patientId: reportColumnTypes.patientId,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    application: reportColumnTypes.application,
    applicationId: reportColumnTypes.applicationId,
    memberId: reportColumnTypes.memberId,
    status: reportColumnTypes.status,
    isExhausted: reportColumnTypes.isExhausted,
    applicationExpired: reportColumnTypes.applicationExpired,
    isIrrelevantForRenewal: reportColumnTypes.isIrrelevantForRenewal,
    savingsType: reportColumnTypes.savingsType,
    assistanceType: reportColumnTypes.assistanceType,
    assistanceProgram: reportColumnTypes.assistanceProgram,
    programSponsor: reportColumnTypes.programSponsor,
    approvedAmount: reportColumnTypes.approvedAmount,
    brandName: reportColumnTypes.brandName,
    ingredientName: reportColumnTypes.ingredientName,
    doseFormCategory: reportColumnTypes.doseFormCategory,
    diagnosisDiscovered: reportColumnTypes.diagnosisDiscovered,
    appliedDate: reportColumnTypes.appliedDate,
    approvedDate: reportColumnTypes.approvedDate,
    lookbackPeriodStartDate: reportColumnTypes.lookbackPeriodStartDate,
    validThrough: reportColumnTypes.validThrough,
    effectiveIndefinitely: reportColumnTypes.effectiveIndefinitely,
    canceledDate: reportColumnTypes.canceledDate,
    rejectedDate: reportColumnTypes.rejectedDate,
    updatedAt: reportColumnTypes.updatedAt,
    lastUpdatedBy: reportColumnTypes.lastUpdatedBy,
    tags: reportColumnTypes.tags,
    bin: reportColumnTypes.bin,
    pcn: reportColumnTypes.pcn,
    group: reportColumnTypes.group,
    expiryDate: reportColumnTypes.expiryDate,
    zip: reportColumnTypes.zip,
    physicianName: reportColumnTypes.physicianName,
    planMarket: reportColumnTypes.planMarket,
    payerName: reportColumnTypes.payerName
  },
  enrollment_claims: {
    approvedDate: reportColumnTypes.enrollmentApprovedDate,
    assigneeName: reportColumnTypes.enrollmentAssigneeName,
    userGroup: reportColumnTypes.enrollmentUserGroup,
    patientFacility: reportColumnTypes.patientFacility,
    patientId: reportColumnTypes.patientId,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    application: reportColumnTypes.application,
    applicationId: reportColumnTypes.applicationId,
    memberId: reportColumnTypes.memberId,
    providedBy: reportColumnTypes.providedBy,
    assistanceProgramName: reportColumnTypes.assistanceProgramName,
    savingsType: reportColumnTypes.savingsType,
    assistanceType: reportColumnTypes.assistanceType,
    validThrough: reportColumnTypes.validThrough,
    effectiveIndefinitely: reportColumnTypes.effectiveIndefinitely,
    isIrrelevantForRenewal: reportColumnTypes.isIrrelevantForRenewal,
    approvedAmount: reportColumnTypes.approvedAmount,
    fundBalance: reportColumnTypes.fundBalance,
    totalRequestedAmount: reportColumnTypes.totalRequestedAmount,
    totalPaidAmount: reportColumnTypes.totalPaidAmount,
    totalDeniedAmount: reportColumnTypes.totalDeniedAmount,
    totalPatientResponsibility: reportColumnTypes.totalPatientResponsibility,
    latestPaidDate: reportColumnTypes.latestPaidDate,
    brandName: reportColumnTypes.brandName,
    ingredientName: reportColumnTypes.ingredientName,
    doseFormCategory: reportColumnTypes.doseFormCategory,
    bin: reportColumnTypes.bin,
    pcn: reportColumnTypes.pcn,
    group: reportColumnTypes.group,
    expiryDate: reportColumnTypes.expiryDate,
    zip: reportColumnTypes.zip,
    tags: reportColumnTypes.tags
  },
  claims: {
    claimDate: reportColumnTypes.claimDate,
    assigneeName: reportColumnTypes.assigneeName,
    userGroup: reportColumnTypes.userGroup,
    facility: reportColumnTypes.facility,
    patient: reportColumnTypes.patient,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    assistanceprogramapplication: reportColumnTypes.assistanceprogramapplication,
    applicationId: reportColumnTypes.applicationId,
    memberId: reportColumnTypes.memberId,
    claimId: reportColumnTypes.claimId,
    status: reportColumnTypes.claimStatus,
    followUpDate: reportColumnTypes.followUpDate,
    claimServiceDates: reportColumnTypes.claimServiceDates,
    providedBy: reportColumnTypes.providedBy,
    assistanceProgramName: reportColumnTypes.assistanceProgramName,
    savingsType: reportColumnTypes.savingsType,
    assistanceType: reportColumnTypes.assistanceType,
    submittedDate: reportColumnTypes.submittedDate,
    approvedDate: reportColumnTypes.claimApprovedDate,
    receivedDate: reportColumnTypes.receivedDate,
    claimTotalAmount: reportColumnTypes.claimTotalAmount,
    paidAmount: reportColumnTypes.paidAmount,
    deniedAmount: reportColumnTypes.deniedAmount,
    patientResponsibilityAmount: reportColumnTypes.patientResponsibilityAmount,
    balance: reportColumnTypes.balance,
    payableTo: reportColumnTypes.payableTo,
    paymentType: reportColumnTypes.paymentType,
    checkNumber: reportColumnTypes.checkNumber,
    accountNumbers: reportColumnTypes.accountNumbers,
    updatedAt: reportColumnTypes.claimUpdatedAt,
    updatedBy: reportColumnTypes.claimUpdatedBy,
    tags: reportColumnTypes.tags
  },
  claim_line_items: {
    assigneeName: reportColumnTypes.assigneeName,
    userGroup: reportColumnTypes.userGroup,
    patient: reportColumnTypes.patient,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    assistanceprogramapplication: reportColumnTypes.assistanceprogramapplication,
    claimId: reportColumnTypes.claimId,
    serviceDate: reportColumnTypes.serviceDate,
    amount: reportColumnTypes.amount,
    accountNumber: reportColumnTypes.accountNumber,
    serviceType: reportColumnTypes.serviceType,
    serviceCode: reportColumnTypes.serviceCode,
    bnName: reportColumnTypes.bnName,
    inName: reportColumnTypes.inName,
    serviceName: reportColumnTypes.serviceName,
    updatedAt: reportColumnTypes.claimUpdatedAt,
    updatedBy: reportColumnTypes.claimUpdatedBy
  },
  orders: {
    orderDate: reportColumnTypes.orderDate,
    assigneeName: reportColumnTypes.pharmacyAssigneeName,
    userGroup: reportColumnTypes.pharmacyUserGroup,
    facilityValue: reportColumnTypes.facilityValue,
    orderId: reportColumnTypes.orderId,
    patient: reportColumnTypes.patient,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    assistanceprogramapplication: reportColumnTypes.assistanceprogramapplication,
    memberId: reportColumnTypes.memberId,
    accountNumber: reportColumnTypes.accountNumber,
    assistanceProgramName: reportColumnTypes.assistanceProgramName,
    providedBy: reportColumnTypes.providedBy,
    orderType: reportColumnTypes.orderType,
    orderStatus: reportColumnTypes.orderStatus,
    hcpcs: reportColumnTypes.hcpcs,
    drugBrandName: reportColumnTypes.drugBrandName,
    inName: reportColumnTypes.inName,
    doseFormCategory: reportColumnTypes.doseFormCategory,
    administrationDate: reportColumnTypes.administrationDate,
    estimatedDelivery: reportColumnTypes.estimatedDelivery,
    arriveDate: reportColumnTypes.arriveDate,
    billVoided: reportColumnTypes.billVoided,
    billVoidedDate: reportColumnTypes.billVoidedDate,
    isSkipped: reportColumnTypes.isSkipped,
    dosageUnitAndValue: reportColumnTypes.dosageUnitAndValue,
    totalAmount: reportColumnTypes.totalAmount,
    orderPhysicianName: reportColumnTypes.orderPhysicianName,
    orderUpdatedBy: reportColumnTypes.orderUpdatedBy,
    orderUpdatedAt: reportColumnTypes.orderUpdatedAt,
    tags: reportColumnTypes.tags
  },
  order_line_items: {
    ...orderLineItemColumnTypes
  },
  completed_order_line_items: {
    ...orderLineItemColumnTypes
  },
  completed_orders: {
    orderDate: reportColumnTypes.orderDate,
    assigneeName: reportColumnTypes.pharmacyAssigneeName,
    userGroup: reportColumnTypes.pharmacyUserGroup,
    facilityValue: reportColumnTypes.facilityValue,
    orderId: reportColumnTypes.orderId,
    patient: reportColumnTypes.patient,
    mrn: reportColumnTypes.mrn,
    patientName: reportColumnTypes.patientName,
    dob: reportColumnTypes.dob,
    assistanceprogramapplication: reportColumnTypes.assistanceprogramapplication,
    memberId: reportColumnTypes.memberId,
    accountNumber: reportColumnTypes.accountNumber,
    assistanceProgramName: reportColumnTypes.assistanceProgramName,
    providedBy: reportColumnTypes.providedBy,
    orderType: reportColumnTypes.orderType,
    orderStatus: reportColumnTypes.orderStatus,
    hcpcs: reportColumnTypes.hcpcs,
    drugBrandName: reportColumnTypes.drugBrandName,
    inName: reportColumnTypes.inName,
    doseFormCategory: reportColumnTypes.doseFormCategory,
    administrationDate: reportColumnTypes.administrationDate,
    estimatedDelivery: reportColumnTypes.estimatedDelivery,
    arriveDate: reportColumnTypes.arriveDate,
    billVoided: reportColumnTypes.billVoided,
    billVoidedDate: reportColumnTypes.billVoidedDate,
    isSkipped: reportColumnTypes.isSkipped,
    dosageUnitAndValue: reportColumnTypes.dosageUnitAndValue,
    totalAmount: reportColumnTypes.totalAmount,
    orderPhysicianName: reportColumnTypes.orderPhysicianName,
    orderUpdatedBy: reportColumnTypes.orderUpdatedBy,
    orderUpdatedAt: reportColumnTypes.orderUpdatedAt,
    tags: reportColumnTypes.tags
  }
};

export { ReportColumns };
